/** Shared gallery assets for the home section and `/gallery` page */
export const GALLERY_IMAGES = [
  {
    src: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1600&q=80',
    alt: 'Green wheat field under a bright sky',
    title: 'Winter wheat trial plot',
  },
  {
    src: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?auto=format&fit=crop&w=1600&q=80',
    alt: 'Crop irrigation in a green field',
    title: 'Irrigation and crop care',
  },
  {
    src: 'https://images.unsplash.com/photo-1574943320919-288b6ab7d7c2?auto=format&fit=crop&w=1600&q=80',
    alt: 'Hands holding young seedlings',
    title: 'Seedling quality check',
  },
  {
    src: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&w=1600&q=80',
    alt: 'Tractor working in a lush crop field',
    title: 'Field operations',
  },
  {
    src: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=1600&q=80',
    alt: 'Rows of plants inside a greenhouse',
    title: 'Protected cultivation',
  },
  {
    src: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?auto=format&fit=crop&w=1600&q=80',
    alt: 'Vegetable harvest in wooden crates',
    title: 'Harvest ready for market',
  },
  {
    src: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1600&q=80',
    alt: 'Orchard trees in neat rows',
    title: 'Orchard establishment',
  },
  {
    src: 'https://images.unsplash.com/photo-1560493670016-0f2bf3966bbb?auto=format&fit=crop&w=1600&q=80',
    alt: 'Sunset over farmland',
    title: 'End of season — farm at dusk',
  },
];
